module.exports = __webpack_public_path__ + "static/alex-policastro-resume-2020-4e7439db1f8f8aa49a2f7b76b88ccbca.pdf";